import React from 'react';
import Edit from 'containers/rest/Edit';
import Form from '../components/Form';

const LanguagesEdit = props => (
  <Edit {...props} resource="languages">
    <Form />
  </Edit>
);

LanguagesEdit.propTypes = {};

export default LanguagesEdit;
